import { SelectionRepository } from 'src/projects/SelectionRepository.ts';
import { UserSettings } from 'src/types/UserSettings.ts';
import { BelimoTranslate } from 'src/common/hooks/useBelimoTranslate.ts';
import { WorkBook } from 'src/projects/hooks/composeExcelBuffer.ts';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { createReduceSelections } from 'src/projects/utils/createReduceSelections.ts';

export const exportAllPrepare = async ({
    selectionRepository,
    userSettings,
    t,
}: {
    selectionRepository: SelectionRepository;
    userSettings: UserSettings;
    t: BelimoTranslate;
}): Promise<WorkBook> => {
    const reduceSelections = createReduceSelections({
        userSettings,
        t,
    });
    return {
        actuators: selectionRepository
            .filter('actuators')
            .reduce(reduceSelections, { columns: [], rows: [], name: t(MESSAGES.Actuators) }),
        sensors: selectionRepository
            .filter('sensors')
            .reduce(reduceSelections, { columns: [], rows: [], name: t(MESSAGES.Sensors) }),
        valves: selectionRepository
            .filter('valves')
            .reduce(reduceSelections, { columns: [], rows: [], name: t(MESSAGES.Valves) }),
    };
};
